/****
*************
*************
  Off-Canvas Nav Functions
*************
*************
*****/
$('#desktopToggler').click(function() {
  $('.off-canvas-transform-menu').addClass('nav-flex');
  $('#siteVisibleArea').removeClass('site-visible-area-reverse');
  $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-reverse');
  $('#siteVisibleArea').addClass('site-visible-area');
  $('#siteVisibleAreaInner').addClass('site-visible-area-inner');
  $('#canvasX').delay(500).fadeIn();
  $('#offCanvasMenu').delay(500).hide().animate({left:"auto", opacity:"show"}, 1000);
});

var mobileClicked = 0;

$('#mobileToggler').click(function() {
  if( mobileClicked == 0) {
    $('#siteVisibleArea').removeClass('site-visible-area-reverse-mobile');
    $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-reverse-mobile');
    $('#siteVisibleArea').addClass('site-visible-area-mobile');
    $('#siteVisibleAreaInner').addClass('site-visible-area-inner-mobile');
    $('#offCanvasMobile').delay(500).hide().animate({left:"auto", opacity:"show"}, 1000);
    mobileClicked = 1;
  }
  else if(mobileClicked == 1) {
    $('#siteVisibleArea').addClass('site-visible-area-reverse-mobile');
    $('#siteVisibleAreaInner').addClass('site-visible-area-inner-reverse-mobile');
    $('#siteVisibleArea').removeClass('site-visible-area-mobile');
    $('#siteVisibleAreaInner').removeClass('site-visible-area-inner-mobile');
    $('#offCanvasMenu').hide();
    mobileClicked = 0;
  }
});

$('#canvasX').click(function() {
  $('.off-canvas-transform-menu').removeClass('nav-flex');
  $('#siteVisibleArea').addClass('site-visible-area-reverse');
  $('#siteVisibleAreaInner').addClass('site-visible-area-inner-reverse');
  $('#siteVisibleArea').removeClass('site-visible-area');
  $('#siteVisibleAreaInner').removeClass('site-visible-area-inner');
  $('#canvasX').hide();
  $('#offCanvasMenu').hide();
});


/****
*************
*************
  Light / Dark Mode
  Notes: User can set mode preference for session, clears info when user closes tab or window. Otherwise, setting is time-based
*************
*************
*****/
if($('.theme-switch-wrapper')[0]) {
const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
const currentTheme = sessionStorage.getItem('rangeThemeToggle');
const time = new Date();
const startTime = new Date().setHours(8); // 8:00am
const endTime = new Date().setHours(20); // 8:00pm
if (currentTheme) { // If session set, use it
    document.documentElement.setAttribute('data-theme', currentTheme);
    if (currentTheme === 'dark') {
        toggleSwitch.checked = true;
    }
} else if (time.getTime() < startTime || time.getTime() > endTime) { // If outside of daytime hours, set to night mode
    document.documentElement.setAttribute('data-theme', 'dark');
    toggleSwitch.checked = true;
} else {
    toggleSwitch.checked = false;
}
function switchTheme(e) {
    if (e.target.checked) {
        document.documentElement.setAttribute('data-theme', 'dark');
        sessionStorage.setItem('rangeThemeToggle', 'dark');
    }
    else {
        document.documentElement.setAttribute('data-theme', 'light');
        sessionStorage.setItem('rangeThemeToggle', 'light');
    }
}
toggleSwitch.addEventListener('change', switchTheme, false);
}
/****
*************
*************
  Document Ready Functions
*************
*************
*****/
jQuery(document).ready(function($) {
  //Transparent nav scrolling function
  //detect page top
  if($('.header-style-1-nav')[0]) {
      $(window).load(function() {
          if ($(window).scrollTop() >= 0.1) {
              $('.header-scroll').addClass('scrolling');
          } else {
              $('.header-scroll').removeClass('scrolling');
          }
      });
      $(window).scroll(function() {
          if ($(window).scrollTop() >= 0.1) {
              $('.header-scroll').addClass('scrolling');
          } else {
              $('.header-scroll').removeClass('scrolling');
          }
      });
  }

  // Toggle SVG icons on menu open / close
  $("button.navbar-toggler").click(function(){
    $(".navbar-toggler-icon").toggleClass("navbar-toggler-icon-close");
  });

if($('.slick-content')[0]) {
  $('.slick-content').slick({
     dots: true,
     infinite: false,
     speed: 500,
     cssEase: 'linear',
     swipeToSlide: 'true',
     autoplay: false,
     arrows: false,
     slidesToShow: 1,
     slidesToScroll: 1,
     adaptiveHeight:true,
   });
 }

 if($('.service-images')[0]) {
          $('.service-images').not('.slick-initialized').slick({
            dots: false,
            infinite: false,
            speed: 500,
            cssEase: 'linear',
            swipeToSlide: 'true',
            autoplay: true,
            arrows: false,
            nextArrow: '<i class="fas fa-arrow-circle-right slick-arrow-right"></i>',
            prevArrow: '<i class="fas fa-arrow-circle-left slick-arrow-left"></i>',
            slidesToShow: 1,
            asNavFor: '.service-thumbs',
            slidesToScroll: 1,
          });
      }
    $('.service-thumbs').slick({
      autoplay: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      focusOnSelect: true,
    });


 if($('.slick-testimonials')[0]) {
   $('.slick-testimonials').slick({
      dots: true,
      infinite: false,
      speed: 500,
      cssEase: 'linear',
      swipeToSlide: 'true',
      autoplay: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight:true,
    });
  }

  //Affiliate Slider
  if($('.dealer-brands.slider')[0]) {
      $('.dealer-brands.slider').not('.slick-initialized').slick({
        dots: false,
        speed: 4500,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 0,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows:true,
        responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
        },
      }, {
        breakpoint: 520,
        settings: {
          slidesToShow: 2,
        },
      }],
    });
  }

   $('.next-slick').click(function(){
     $("#content-repeater").slick('slickNext');
   });
   $('.first-slick').click(function(){
     $("#content-repeater").slick('slickGoTo', 0);
   });

   $('.slick-next-slide').click(function(){
     $("#testimonial-repeater").slick('slickNext');
   });
   $('.slick-first-slide').click(function(){
     $("#testimonial-repeater").slick('slickGoTo', 0);
   });

  if($('.card-slider')[0]) {
    $('.card-slider').slick({
      dots: false,
      infinite: true,
      nextArrow: '<div class="arrow-right"><i class="far fa-chevron-right"></i></div>',
      prevArrow: '<div class="arrow-left"><i class="far fa-chevron-left"></i></div>',
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
          },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
          }],
    });
  }
  if($('.slick-logo-banner')[0]) {
    $('.slick-logo-banner').slick({
        dots: true,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        swipeToSlide: 'true',
        autoplay: true,
        pauseOnHover:true,
        pauseOnFocus:false,
        autoplaySpeed: 5000,
        nextArrow: '<div class="arrow-right"><i class="far fa-chevron-right"></i></div>',
        prevArrow: '<div class="arrow-left"><i class="far fa-chevron-left"></i></div>',
        arrows: true,
        slidesToShow: 5,
        adaptiveHeight:false,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
            },
          },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false,
          },
        }],
    });
  }
  /** hero slider **/
  $('.hero-bkg-slider, .absolute-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 1500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      pauseOnHover:false,
      pauseOnFocus:false,
      autoplaySpeed: 8000,
  });

  /** navigation hover functions **/
  function toggleDropdown (e) {
    var d = $(this);
    var m = $($(this).find('.dropdown-menu')[0]);
    console.log($(this));
    setTimeout(function(){
      var shouldOpen = e.type !== 'click' && d.is(':hover');
      m.toggleClass('show', shouldOpen);
      d.toggleClass('show', shouldOpen);
      $('[data-toggle="dropdown"]', d).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 50 : 0);
  }

  $(window).on('load resize', function() {
      $('body').on('mouseenter mouseleave','.dropdown',toggleDropdown);
  });

  //modal functions for team bios
  $('.open-bio').click(function() {
     $('.header-style-3-nav').css({'z-index':'2'});
     var bio_id = $(this).attr('bio_target');
     if($(this).hasClass('bio_999')) {
       $('#bio_999').addClass('d-block');
     } else {
       $('#'+bio_id).addClass('d-block');
     }
  });
  $('.modal-header button.close').click(function() {
      $('.modal').removeClass('d-block');
      $('.modal').addClass('d-none');
      $('.header-style-3-nav').css({'z-index':'10001'});
  });

  // to activate lightgallery
  $(document).ready(function() {
      $(".add-lightgallery").lightGallery({
            selector: '.gallery-image'
        });
  });
});



// WEBPACK FOOTER //
// ./scripts/theme.js